import fetch from 'isomorphic-fetch';

export const logOut = () => {
  const { host, protocol } = window.location;
  return fetch(`${protocol}//${host}/api/logout`, {
    headers: {
      'Content-Type': 'application/json',
    },
    body: '{}',
    method: 'POST',
  });
};
